module.exports = __webpack_public_path__ + "img/smiley.5d88e487.svg";